module.exports = __webpack_public_path__ + "img/access.238a7181.svg";